import React from 'react';

function About() {
  return (
    <>
      <section className="about-location-banner" id="about-location-banner">
        <h3>50+ Pre Wedding Backdrops&nbsp; Photography &amp; Cinematography Location in Agra</h3>
      </section>
    </>
  );
}

export default About;
